import styled from 'styled-components'
import { SIZES } from '../../../constants'
import Link from '../../utils/Link'

export default styled(Link)`
  color: #333;
  display: flex;
  flex-basis: 128px;
  flex-direction: column;
  display: -ms-flexbox;
  -ms-flex-direction: column;
  height: 100%;
  &:hover {
    text-decoration: none;
  }
  &:hover .title {
    text-decoration: underline;
  }
  @media (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    flex-direction: row;
    -ms-flex-direction: row;
  }
`
